var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnicage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 70,
    viewBox: "0 0 155 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_3705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.86 35.979V28.6364H37.08V42.2339H32.86V40.4662C31.98 41.7172 30.46 42.4696 28.83 42.4605C27.3 42.4968 25.81 41.9982 24.68 41.0554C23.56 40.1217 23 38.7348 23 36.8946V28.6364H27.22V36.0243C27.22 38.1184 28.07 39.1608 29.76 39.1608C30.58 39.1608 31.37 38.8707 31.94 38.3359C32.59 37.6923 32.92 36.8402 32.85 35.9699L32.86 35.979Z",
    fill: "#A8BE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1304 34.6736V42.27H39.9404V28.6725H44.1304V30.1954C45.2204 29.0986 46.7704 28.464 48.4004 28.4459C49.9004 28.4006 51.3404 28.9354 52.3804 29.9144C53.5004 31.0294 54.0704 32.498 53.9804 33.9937V42.27H49.7904V34.5738C49.7904 32.4798 48.9404 31.4374 47.2504 31.4374C46.4304 31.4374 45.6404 31.7274 45.0604 32.2623C44.3904 32.915 44.0504 33.7943 44.1204 34.6826L44.1304 34.6736Z",
    fill: "#A8BE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3803 26.2885C57.4203 25.3911 57.4303 23.9588 58.4203 23.0886C59.4103 22.2183 60.9903 22.2274 61.9503 23.1248C62.9103 24.0223 62.9003 25.4546 61.9103 26.3248C61.4303 26.7508 60.7903 26.9775 60.1303 26.9684C59.4703 26.9684 58.8403 26.7237 58.3803 26.2885Z",
    fill: "#A8BE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9204 39.1064C72.4304 39.043 73.8204 38.345 74.6704 37.2118L77.1604 39.75C75.2204 41.5631 73.1304 42.4696 70.8704 42.4696C68.7604 42.5149 66.7104 41.8259 65.1604 40.5296C63.6004 39.2333 62.7504 37.3841 62.8304 35.4623C62.7604 33.5315 63.6204 31.6731 65.1904 30.3678C66.7104 29.0805 68.7104 28.3735 70.7904 28.4007C71.9204 28.4007 73.0304 28.6092 74.0704 29.008C75.1704 29.4159 76.1704 30.0324 76.9904 30.812L74.8104 33.3955C73.8504 32.3802 72.4604 31.7819 70.9904 31.7547C69.9404 31.7366 68.9304 32.0811 68.1604 32.7247C67.3404 33.4317 66.9104 34.4198 66.9704 35.4442C66.8904 36.4685 67.3304 37.4657 68.1604 38.1637C68.9204 38.7801 69.9004 39.1155 70.9204 39.1064Z",
    fill: "url(#paint0_linear_365_3705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.63 42.2611H87.68V40.6203C86.75 41.7806 85.26 42.4696 83.67 42.4696C82.21 42.5058 80.78 42.0616 79.66 41.2186C78.58 40.3846 77.98 39.1518 78.04 37.8736C77.96 36.6317 78.59 35.4532 79.72 34.7462C81.1 33.9938 82.69 33.6312 84.3 33.7037H87.43V33.6312C87.43 32.1808 86.58 31.4556 84.89 31.4556C84.1 31.4646 83.32 31.6006 82.59 31.8544C81.85 32.0811 81.16 32.4074 80.54 32.8244L78.67 30.3678C80.63 29.0715 83 28.3916 85.42 28.4188C87.03 28.3463 88.62 28.7905 89.92 29.6607C91.08 30.4947 91.65 31.8 91.65 33.5859V42.2611H91.63ZM87.41 37.0668V36.3869H84.79C83.1 36.4051 82.25 36.8855 82.25 37.8283C82.22 38.2725 82.45 38.6985 82.85 38.9523C83.36 39.2424 83.96 39.3784 84.57 39.3512C85.29 39.3693 85.99 39.1518 86.56 38.7438C87.12 38.345 87.44 37.7195 87.41 37.0759V37.0668Z",
    fill: "#28424E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46 39.9585C104.22 41.2548 102.42 41.9891 100.52 41.9528C98.6595 41.9891 96.8595 41.3364 95.5495 40.1489C94.1495 38.8707 93.4095 37.1121 93.4995 35.3173C93.4195 33.4771 94.1795 31.6822 95.5795 30.3587C96.7995 29.1349 98.5295 28.4369 100.34 28.4188C102.09 28.4007 103.74 29.144 104.78 30.4131V28.6091H108.97V40.4934C108.99 41.6084 108.75 42.7143 108.27 43.7386C107.86 44.618 107.22 45.3794 106.4 45.9686C104.84 47.0836 102.91 47.6819 100.92 47.6366C99.7595 47.6366 98.6095 47.4644 97.4995 47.138C96.3995 46.8389 95.3595 46.3584 94.4395 45.7329L96.0595 42.8684C97.2995 43.7749 98.8395 44.2735 100.43 44.2916C101.74 44.3551 103.04 43.9834 104.08 43.2491C105 42.5511 105.45 41.4543 105.45 39.9495L105.46 39.9585ZM104.88 35.1541C104.94 34.2113 104.58 33.2867 103.88 32.5887C103.23 31.9723 102.33 31.6278 101.39 31.6459C100.43 31.6369 99.5095 31.9723 98.8295 32.5887C98.0895 33.2686 97.6995 34.1932 97.7595 35.145C97.7095 36.115 98.0895 37.0577 98.8095 37.7739C99.4695 38.4175 100.4 38.771 101.36 38.7529C102.32 38.771 103.23 38.4084 103.87 37.7648C104.56 37.0487 104.93 36.115 104.88 35.1631V35.1541Z",
    fill: "#28424E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.88 40.2939C123.28 41.7171 121.12 42.4967 118.88 42.4695C116.79 42.533 114.76 41.8441 113.22 40.5568C111.69 39.2152 110.88 37.3569 110.97 35.426C110.86 33.5043 111.68 31.6369 113.22 30.3043C114.67 29.0624 116.6 28.3825 118.6 28.4097C120.52 28.3644 122.39 28.9717 123.85 30.1049C125.32 31.2833 126.11 32.9966 126.02 34.7643V36.8039H115.16C115.29 37.5472 115.76 38.209 116.44 38.626C117.16 39.0883 118.02 39.324 118.9 39.3059C120.27 39.3421 121.59 38.8435 122.53 37.9461L124.88 40.2758V40.2939ZM120.85 32.208C120.26 31.7547 119.51 31.519 118.74 31.5281C117.93 31.5281 117.14 31.7638 116.49 32.208C115.82 32.6431 115.38 33.3139 115.29 34.0572H121.88C121.82 33.3411 121.45 32.6793 120.85 32.208Z",
    fill: "#28424E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1198 42.669C55.9598 37.9371 55.8898 33.042 56.8998 28.2828L60.8898 28.9627C59.9798 33.2233 60.0498 37.6017 61.0798 41.8441L57.1098 42.669H57.1198Z",
    fill: "#A8BE2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38 43.1131C129.31 42.8139 128.17 43.3488 127.84 44.3187C127.65 44.8717 127.44 45.4247 127.22 45.9595C120.53 62.1768 100.61 70.4078 82.7302 64.3433C79.6902 63.3099 76.8202 61.8958 74.2102 60.1372C68.3902 56.1939 64.0702 50.7096 61.8702 44.4275L57.9902 45.5334C64.4302 63.9717 86.1502 74.1879 106.49 68.3501C117.8 65.1048 126.84 57.318 131.01 47.2467C131.26 46.6394 131.49 46.023 131.71 45.4065C132.04 44.4366 131.45 43.4122 130.39 43.104L130.38 43.1131Z",
    fill: "url(#paint1_linear_365_3705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71 24.6024C131.5 23.986 131.27 23.3695 131.02 22.7622C123.55 4.64124 101.29 -4.55974 81.3001 2.21182C71.8301 5.42083 64.1201 11.8661 59.8301 20.1696L63.5001 21.7469C71.6001 6.07351 92.1801 -0.679922 109.48 6.66274C117.67 10.1437 124.03 16.3895 127.2 24.0676C127.43 24.6024 127.63 25.1644 127.82 25.7174C128.16 26.6873 129.3 27.2312 130.37 26.923C131.44 26.6239 132.04 25.5905 131.71 24.6205V24.6024Z",
    fill: "url(#paint2_linear_365_3705)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_365_3705",
    x1: 62.8504,
    y1: 35.4374,
    x2: 77.1829,
    y2: 35.4374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BE2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8BA236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#6D853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#546C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#405948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#324C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2A444D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28424E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_365_3705",
    x1: 57.9827,
    y1: 56.5202,
    x2: 131.79,
    y2: 56.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BE2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9CB332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#79903A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5B7442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#455E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#354E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2B454D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28424E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_365_3705",
    x1: 59.8351,
    y1: 13.5046,
    x2: 131.798,
    y2: 13.5046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BE2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9CB332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#79903A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5B7442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#455E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#354E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2B454D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28424E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_3705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108.8,
    height: 70,
    fill: "white",
    transform: "translate(23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicage);
export default __webpack_public_path__ + "static/media/unicage.027e8e22091d23e982bc2fae96e3e587.svg";
export { ForwardRef as ReactComponent };